export default {
    navigationBarTitleText: '验收'
  };
  